import { render, staticRenderFns } from "./ChooseDirection.vue?vue&type=template&id=96df8b1c&scoped=true"
import script from "./ChooseDirection.vue?vue&type=script&lang=js"
export * from "./ChooseDirection.vue?vue&type=script&lang=js"
import style0 from "./ChooseDirection.vue?vue&type=style&index=0&id=96df8b1c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96df8b1c",
  null
  
)

export default component.exports